export default __webpack_public_path__ + "static/media/logo192.65595b20.png";